import { transition } from '@pixelunion/animations';
import {
  trapFocus,
  removeTrapFocus,
} from '@shopify/theme-a11y';

export default class DrawerNavSubmenu {
  constructor(settings) {
    this.menu = settings.submenu;
    this.trigger = settings.trigger;
    this.parentMenu = settings.parentMenu;
    this.tier = settings.tier;
    this.drawerMenu = settings.drawerMenu;
    this.submenu = null;

    this.backButton = this.menu.querySelector('[data-drawer-back-button]');
    this.closeButton = this.menu.querySelector('[data-drawer-close-button]');
    this.flyout = this.menu.querySelector('[data-drawer-submenu-flyout]');
    this.overlay = this.menu.querySelector('[data-drawer-submenu-overlay]');
    this.submenuTriggers = this.menu.querySelectorAll(`[data-drawer-submenu-button="tier-${this.tier}"]`);

    this.abortController = new AbortController();

    this.flyoutAnimation = transition({ el: this.flyout, state: 'closed' });
    this.overlayAnimation = transition({ el: this.overlay, state: 'closed' });

    const { signal } = this.abortController;
    this.backButton.addEventListener('click', () => this.close(), { signal });
    this.closeButton.addEventListener('click', () => this.drawerMenu.close(), { signal });

    this.submenuTriggers.forEach(submenuTrigger => {
      submenuTrigger.addEventListener('click', e => this.openSubmenu(e), { signal });
    });

    this.open();
  }

  open() {
    this.menu.dataset.open = true;
    this.flyoutAnimation.animateTo('open');
    this.overlayAnimation.animateTo('open');

    this.menu.focus();
    trapFocus(this.menu);
  }

  close() {
    removeTrapFocus(this.menu);
    this.trigger.focus();
    trapFocus(this.parentMenu);

    this.parentMenu.dataset.childOpen = false;

    this.overlayAnimation.animateTo('closed');
    this.flyoutAnimation.animateTo('closed')
      .then(() => {
        this.unload();
      });
  }

  openSubmenu(e) {
    const submenuTrigger = e.target;
    const submenu = submenuTrigger.nextElementSibling;

    this.menu.dataset.childOpen = true;

    this.submenu = new DrawerNavSubmenu({
      submenu,
      trigger: submenuTrigger,
      parentMenu: this.menu,
      tier: this.tier + 1,
      drawerMenu: this.drawerMenu,
    });
  }

  unload() {
    if (this.submenu) {
      this.submenu.unload();
    }

    this.menu.dataset.open = false;
    this.menu.dataset.childOpen = false;

    this.flyoutAnimation.animateTo('closed', { force: true });
    this.overlayAnimation.animateTo('closed', { force: true });

    this.flyoutAnimation.unload();
    this.overlayAnimation.unload();
    this.abortController.abort();
  }
}
